import { AssessmentStatus } from '../common/utils/assessmentStatus';
import { ClinicAccountItems } from './ClinicAccountType';
import { InterviewFormatDto } from './InterviewQuestionTypes';
import { LatestAssessmentByPatientItem, PatientDiagnosisInfo, PatientInfo } from './PatientRequest';

export interface PatientInfoCardProps {
  data?: PatientInfo;
  clinicAccounts?: ClinicAccountItems[];
  patientIdOnly?: boolean;
  interview?: InterviewFormatDto;
  showDiagnosis?: boolean;
  showCoCM?: boolean;
  diagnosisData?: PatientDiagnosisInfo[];
  onClickEditPatient?: () => void;
  onClickEditFeedback?: () => void;
  onReloadPatient?: () => void;
}

export enum MeasurementPacketType {
  IntakePacket = 'intakePacket',
  MeasurementPacket = 'measurementPacket',
}

export interface IntakePacketPopupBodyProp {
  setChoseOption: (data?: IntakePopupType) => void;
  hasEmailOrPhoneNumber?: boolean;
}

export interface ChangeInterviewModeToClinicianResponse {
  newInterviewResultId?: number;
}

export interface ChangeMonitorModeToClinicianResponse {
  newTrackerResultId?: number;
}

export interface LatestMonitorResultsByPatientResponse {
  monitorResults?: LatestAssessmentByPatientItem[];
}

export interface CheckShowPopupIntakePacketResponse {
  interviewResultId?: number;
  interviewTypeId?: number;
  trackerResultId?: number;
  trackerTypeId?: number;
  type?: MeasurementPacketType;
  trial?: boolean;
  statusData?: AssessmentStatus;
}

export enum IntakePopupType {
  EmailAndTextTheQuestionsToThePatient = 'emailAndTextTheQuestionsToThePatient',
  PatientWillFillOutTheQuestions = 'patientWillFillOutTheQuestions',
  DoNotSendTheIntakePacket = 'doNotSendTheIntakePacket',
}

export interface CoCMStatusType {
  id: number;
  name: string;
  code: string;
}

export enum PrimaryDiagnosisType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Quaternary = 'quaternary',
  Other = 'other',
}

export const TimeframeProperties = {
  Timeframe: 'timeframe',
  ICDCode: 'icdCode',
};
